var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-dnd-html5-backend/~/lodash/_Symbol.js
 ** module id = 395
 ** module chunks = 0
 **/